<template>
  <div class=" messagecenterxiaoxilist">
      <XR-head titleText="帮助中心" :rightShow="false" ref="headObj"></XR-head>
      <mu-list ref="list">
        <mu-list-item class="head" :title="categoryName">
             <mu-avatar :src="'/static/messageUsercenter/'+icon" slot="leftAvatar"/>
        </mu-list-item>
        <mu-list-item class="problem" :title="articleEntity.ArticleTitle" v-for="articleEntity in articleList" :key="articleEntity.Id"
          :to="'/helperDetail?categoryName='+categoryName+'&id='+articleEntity.Id">
        </mu-list-item>
      </mu-list>
      <template>
        <div class="qq_footer"><img class="xuri_logo"  src="/static/refresh/more.png" />亲，暂无更多内容</div>
      </template>
  </div>
</template>
<script>
export default {
  data() {
    return {      
      articleList:[],
      icon :this.$route.query.icon,
      categoryName: this.$route.query.categoryName
    }
  },
  mounted: function() {
     this.getHelperCategoryList()
  },
  methods: {
     
    getHelperCategoryList(){
      var ths = this;   
      ths.$post(
        "/Shop/ArticleServer/GetHealthyAricleListByCategoryId",{CategoryId:this.$route.query.id}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false   
          ths.articleList = res.Data
          ths.$refs.XRtoast.hide()
        }
      });
    },
  }
   
};
</script>

<style>
    .messagecenterxiaoxilist .mu-list{
      background: #fff;
      margin-top: 15px;
    }
    .messagecenterxiaoxilist .mu-list .head .mu-item {
      border-bottom: 1px solid #f5f5f5;
    }
    .messagecenterxiaoxilist .mu-list .head .mu-item-left .mu-avatar{
      width: 25px;
      height: 25px;
    }
    .messagecenterxiaoxilist .mu-list .head .mu-item.show-left{
      padding-left: 50px;
    }
    .messagecenterxiaoxilist .mu-list .head .mu-item-content .mu-item-title{
      font-weight: bold;
      font-size: 16px;
    }
    .messagecenterxiaoxilist .mu-list .problem  .mu-item{padding: 10px 16px; }
    .messagecenterxiaoxilist .mu-list .problem:nth-child(2)  .mu-item{padding-top: 16px;}
    .messagecenterxiaoxilist .mu-list .problem .mu-item{border-bottom: 1px solid #f5f5f5;}
    .messagecenterxiaoxilist .mu-list .problem:last-child .mu-item{padding-bottom: 16px;border:none; }
    .messagecenterxiaoxilist .mu-list .problem  .mu-item .mu-item-title{
      font-size: 14px;
      color: #666;
    }
    .messagecenterxiaoxilist .qq_footer{width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 50px;}
    .messagecenterxiaoxilist .qq_footer .xuri_logo{width: 10%;}
</style>



// WEBPACK FOOTER //
// src/pages/helperList.vue